import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';
import { membershipExistsByEmail } from 'src/app/shared/api/payments';
import { useLoginState } from 'src/app/shared/hooks/session';

export function useIsExistingMember(): () => Promise<boolean> {
	const [{ email }] = usePromotePageState();

	const utilityContext = useUtilityContext();
	const loginState = useLoginState();
	return async function isExistingMember(): Promise<boolean> {
		if (loginState !== 'GUEST') {
			return false;
		}

		return membershipExistsByEmail({ email }, utilityContext);
	};
}
